import { TableColumns } from '@ohpen/enso-ui';
import { FieldType, ImportResult } from '@pmp/api';

export const columns: TableColumns<ImportResult> = [
  {
    title: 'pmp.products.labels.createdAt',
    dataIndex: 'creationTime',
    key: 'creationTime',
    width: 160,
    options: {
      format: {
        type: 'dateTimeLocal',
      },
      filter: 'date',
      sorter: true,
    },
  },
  {
    title: 'global.labels.entityType',
    dataIndex: 'importEntityType',
    key: 'entityType',
    width: 180,
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.ACTION_ENTITY_TYPE,
    },
  },
  {
    title: 'pmp.products.labels.createdBy',
    dataIndex: 'createdBy',
    key: 'createdBy',
    width: 220,
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'global.labels.status',
    dataIndex: 'status',
    key: 'status',
    width: 140,
    options: {
      format: {
        type: 'tag',
      },
      filter: 'select',
      listName: FieldType.ACTION_STATUS,
      sorter: true,
    },
  },
  { title: 'enso.labels.actions', dataIndex: '', key: 'actions', width: 100, fixed: 'right' },
];
